<template>
    <form>
        <div class="sms-form">
            <div class="form-group">
            <textarea class="form-control message-text" rows="10" id="comment" v-model="setsms.sms_text" :maxlength="800"></textarea>
            </div>

            <div class="text-count" v-text="setsms.sms_text.length"></div>
        </div>

        <button type="button" class="btn eg-btn submit-btn" @click="pushsetsms">Save</button>
    </form>
</template>


<script>
import axios from 'axios';
import {setsmsUrl, getsmsUrl, getHeader} from './../../../config';
const status = 1;

export default {
    data() {
        return {
            setsms: {
                sms_text: "",
                status
            }
        }
    },
    mounted () {
        axios.get(getsmsUrl,{headers: getHeader()})
        .then(Response => (
            this.setsms.sms_text = Response.data.data.sms_text
        ))
    },
    methods: {
        pushsetsms(){
            let newSms={
                sms: this.setsms.sms_text
            }
            
            axios.post(setsmsUrl,this.setsms,{headers: getHeader()})
            .then(Response => {
                // console.log(Response)
                if(Response.data.data.error = "false"){
                    this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Message Set',
                    text: 'Quick response SMS has been set successfully.'
                    });
                }
                else {
                    this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Message not Set',
                    text: 'Something went wrong'
                    });
                }
            })

            .catch(function (error) {
                this.$notify({
                group: 'foo',
                type: 'error',
                title: 'ERROR!!!',
                text: 'Something went wrong'
                });
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/parts/qrs.vue